import { defineMessages } from 'react-intl';

const AccountMessages = defineMessages({
  loginHeader: {
    id: 'account.login.header',
    defaultMessage: 'Login',
    description: 'The header for the login dialog'
  },
  loginPrompt: {
    id: 'account.login.prompt',
    defaultMessage: 'Please enter your email address and password to login',
    description: 'The prompt for the login dialog'
  },
  loginFailed: {
    id: 'account.login.failed',
    defaultMessage: 'Invalid email address or password specified',
    description: 'The error to display if authentication for a user fails.'
  },
  emailAddress: {
    id: 'account.emailAddress',
    defaultMessage: 'Email Address',
    description: 'The label text for email address'
  },
  password: {
    id: 'account.password',
    defaultMessage: 'Password',
    description: 'The label text for password'
  },
  confirmPassword: {
    id: 'account.confirmPassword',
    defaultMessage: 'Confirm Password',
    description: 'The label text for the password confirmation field'
  },
  forgotHeader: {
    id: 'account.forgot.header',
    defaultMessage: 'Forgot Your Password?',
    description: 'The header for the forgot dialog'
  },
  forgotPrompt: {
    id: 'account.forgot.prompt',
    defaultMessage: 'Please enter your email address and an account reset link will be emailed to you',
    description: 'The prompt for the forgot dialog'
  },
  forgotComplete: {
    id: 'account.forgot.complete',
    defaultMessage: 'An email with instructions for resetting your password has been sent to your email address.',
    description: 'The message to display a user who has successfully submitted completed the account reset form.'
  },
  resetHeader: {
    id: 'account.reset.header',
    defaultMessage: 'Reset Password',
    description: 'The header for the reset password dialog'
  },
  resetPrompt: {
    id: 'account.reset.prompt',
    defaultMessage: 'Please enter a new password for your account.',
    description: 'The prompt for the reset password dialog'
  },
  resetCompletePrompt: {
    id: 'account.reset.complete',
    defaultMessage: 'Your password has been successfully reset.',
    description: 'The prompt for the reset password dialog'
  },
  passwordsNotEqual: {
    id: 'account.reset.error.notEqual',
    defaultMessage: 'Passwords do not match',
    description: 'Error message to display when password and confirm password are not the same'
  },
  accountUpdated: {
    id: 'account.info.updated',
    defaultMessage: 'Your account has been successfully updated',
    description: 'The message to display when account information has been saved successfully.'
  }
});

export default AccountMessages;



// WEBPACK FOOTER //
// ./src/apps/Account/components/AccountMessages.js